import _ from 'lodash';
import { Link } from 'react-router-dom';
import { rewriteImageUrl } from '../../../helpers';
import { BrandDiscoverModel } from '../../../models/Discover';

const BrandListItem = (brand: BrandDiscoverModel) => {
  return (
    <Link
      className="card product-card"
      to={`/products/search?brand=${brand.id}_${brand.name}`}
    >
      <div className="card-img">
        <img src={rewriteImageUrl(brand.imageUrl)} alt={brand.name} />
      </div>

      <div className="card-details">
        <div className="card-path">
          {brand?.path?.map(category => (
            <span key={category} className="category">
              {category}
            </span>
          ))}
        </div>
        <div className="card-title">{_.unescape(brand?.name)}</div>
        <div className="card-labels">
          {brand?.labels?.map(label => (
            <span key={label} className="card-label">
              {label}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
};

export default BrandListItem;
